import { useEffect } from 'react';

export function useEffectOnce(callback: () => void | (() => void)): void {
  useEffect(() => {
    return callback();
    // do not pass any dependencies, so it is executed only once
    // eslint-disable-next-line
  }, []);
}
